<ion-list mode="ios" lines="none" class="ion-no-margin list-content">
  <ng-container *ngIf="heart">
    <ion-icon
      [src]="'Icons.shadow-game-control' | translate"
      class="img-broken-heart animated fadeIn fast"
    ></ion-icon>
  </ng-container>

  <ion-card mode="ios" color="white-grad" class="card-content">
    <ion-item
      mode="md"
      lines="none"
      color="transparent"
      class="ion-text-center item-text"
    >
      <ion-label
        mode="md"
        color="darkblue"
        class="mpe-font-weight-600 hey-here-reward-day"
      >
        {{ 'Labels.hey-here-reward-day' | translate }}
      </ion-label>
    </ion-item>

    <ion-item
      mode="md"
      lines="none"
      color="transparent"
      class="ion-text-center"
    >
      <ion-label mode="md" color="status-icon-enable" class="more-life">
        {{ 'Labels.more-life' | translate }}

        <ion-icon [src]="'Icons.heart-life' | translate"></ion-icon>
      </ion-label>
    </ion-item>

    <ion-item mode="md" lines="none" color="transparent">
      <ion-button
        size="default"
        mode="md"
        color="gradient-blue"
        class="button-enderstood"
        (click)="onClose(true)"
      >
        <ion-label
          mode="md"
          color="white"
          class="mpe-font-weight-600 go-to-play"
        >
          {{ 'Buttons.go-to-play' | translate }}
        </ion-label>
      </ion-button>
    </ion-item>

    <ion-item mode="md" lines="none" color="transparent">
      <ion-button
        size="default"
        mode="md"
        fill="clear"
        color="grayDemon"
        class="mpe-button-link-simple button-simple"
        (click)="onClose(false)"
      >
        <ion-label mode="md" color="status-icon-enable" class="later">
          {{ 'Buttons.later' | translate }}
        </ion-label>
      </ion-button>
    </ion-item>
  </ion-card>
</ion-list>
